import { takeLatest, put, call } from 'redux-saga/effects'
import * as CONST from './const'
import * as ERRORS from 'Reducers/Errors/const'
import { apiClient } from 'Module/API/Client'
import NProgress from 'nprogress'
import { incUIBlockCounter, decBlockCounter } from 'Reducers/UIBlock/actions'

/**
 * Upload profile image
 *
 * @param {Object} action
 */
function* uploadProfileImage(action) {
  yield put(incUIBlockCounter())
  NProgress.start()

  const { profileId, image, callbacks = {} } = action
  try {
    const response = yield call(
      apiClient.uploadProfileImage,
      profileId,
      image,
      callbacks,
    )
    yield put({
      type: CONST.UPLOAD_PROFILE_IMAGE_SUCCESS,
    })
    callbacks.onSuccess && callbacks.onSuccess(response)
  } catch (ex) {
    console.error(ex)
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: ex,
    })
  }

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Watch upload profile image
 */
export function* watchUploadProfileImage() {
  yield takeLatest(CONST.UPLOAD_PROFILE_IMAGE, uploadProfileImage)
}

/**
 * Upload Client image
 *
 * @param {Object} action
 */
function* uploadClientImage(action) {
  yield put(incUIBlockCounter())
  NProgress.start()

  const { clientId, image, callbacks = {} } = action
  try {
    const response = yield call(
      apiClient.uploadClientImage,
      clientId,
      image,
      callbacks,
    )
    yield put({
      type: CONST.UPLOAD_CLIENT_IMAGE_SUCCESS,
    })
    callbacks.onSuccess && callbacks.onSuccess(response)
  } catch (ex) {
    console.error(ex)
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: ex,
    })
  }

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Watch upload profile image
 */
export function* watchUploadClientImage() {
  yield takeLatest(CONST.UPLOAD_CLIENT_IMAGE, uploadClientImage)
}

/**
 * Upload pitch
 * @param {Object} action
 */
function* uploadPitchFile(action) {
  yield put(incUIBlockCounter())
  NProgress.start()
  const { campaignId, file, callbacks = {} } = action
  try {
    const response = yield call(
      apiClient.uploadPitchFile,
      campaignId,
      file,
      callbacks,
    )

    yield put({
      type: CONST.UPLOAD_PITCH_FILE_SUCCESS,
    })
    callbacks.onSuccess && callbacks.onSuccess(response)
  } catch (ex) {
    console.error(ex)
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: ex,
    })
  }

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Watch upload pitch file
 */
export function* watchUploadPitchFile() {
  yield takeLatest(CONST.UPLOAD_PITCH_FILE, uploadPitchFile)
}

/**
 * Upload a file
 *
 * @param {Object} action
 */
function* uploadFile(action) {
  yield put(incUIBlockCounter())
  NProgress.start()

  const { file, callbacks = {}, mimeType } = action
  try {
    const response = yield call(apiClient.uploadFile, file, callbacks, mimeType)
    yield put({
      type: CONST.UPLOAD_FILE_SUCCESS,
    })
    callbacks.onSuccess && callbacks.onSuccess(response)
  } catch (ex) {
    console.error(ex)
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: ex,
    })
  }

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Watch upload profile image
 */
export function* watchUploadFile() {
  yield takeLatest(CONST.UPLOAD_FILE, uploadFile)
}



// WEBPACK FOOTER //
// ./src/Reducers/Upload/sagas.js